import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import axios from 'axios';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { url } from '../../constant';
import { Typography, Divider, Box } from '@mui/material';

let permissions = {
  admin: null,
  sales: null,
  stock: null,
  whatsAppBulk: null,
  whatsAppChat: null,
  whatsAppStatus: null,
  blockList: null,
  quickWA: null,
  attachment: null,
  device: null
}

export default function FormDialog(props) {
  const [whatsappNumber, setwhatsappNumber] = React.useState(props.selectedRow ? props.selectedRow.whatsappNumber : "")
  const [token, settoken] = React.useState(props.selectedRow ? props.selectedRow.token : "")
  const [email, setEmail] = React.useState(props.selectedRow ? props.selectedRow.email : "")
  const [password, setPassword] = React.useState("")
  const [fileName, setFileName] = React.useState(props.selectedRow ? props.selectedRow.fileName : "")
  const [schemeFileName, setSchemeFileName] = React.useState(props.selectedRow ? props.selectedRow.schemeFileName : "")
  const [stockFileName, setStockFileName] = React.useState(props.selectedRow ? props.selectedRow.stockFileName : "")
  const [activeStaus, setActiveStatus] = React.useState(props.selectedRow ? props.selectedRow.status : "")
  const [isDataLoading, setIsDataLoading] = React.useState(false)
  const [showResetPassword, setShowResetPassword] = React.useState(false)
  const [whatsappAccId, setWhatsappAccId] = React.useState(props.selectedRow ? props.selectedRow.whatsappAccNumber : "")
  const [third_party_api, setWAThirdPartyAPI] = React.useState(props.selectedRow ? props.selectedRow.third_party_api : "")
  const [messageLimit, setMessageLimit] = React.useState(props.selectedRow ? props.selectedRow.msg_limit : "")
  const [devicesAllowed, setDevicesAllowed] = React.useState(props.selectedRow ? props.selectedRow.allowed_app_user : "")
  const [mobileNumber, setMobileNumber] = React.useState(props.selectedRow ? props.selectedRow.mobile_number : "")
  const [expiryDate, setExpiryDate] = React.useState(props.selectedRow ? props.selectedRow.expiry_date : "")
  const [secretKey, setSecretKey] = React.useState(props.selectedRow ? props.selectedRow.secret_key : "")
  const [otp_authentication, setOTPAuth] = React.useState(props.selectedRow ? props.selectedRow.otp_authentication : "")
  const [name, setName] = React.useState(props.selectedRow ? props.selectedRow.name : "")
  const [systemId, setSystemId] = React.useState(props.selectedRow ? props.selectedRow.system_id : "")
  const [accessAllowed, setAccessAllowed] = React.useState(props.selectedRow ? {...permissions, ...props.selectedRow.access_allowed} : {})

// console.log("accessAllowed", accessAllowed);

  const createUser = () => {
    setIsDataLoading(true)

    if(!props.selectedRow){
      axios.post(`${url}/register/`, {
        "whatsapp_phone_no_id": whatsappNumber,
        "password": password,
        "email": email,
        "file_name": fileName,
        "scheme_file_name": schemeFileName,
        "stock_file_name": stockFileName,
        "whatsapp_token": token,
        "whatsapp_account_id": whatsappAccId,
        "allowed_app_user": devicesAllowed,
        "name": name,
        "msg_limit": messageLimit,
        "third_party_api": third_party_api,
        "mobile_number": mobileNumber,
        "expiry_date": expiryDate,
        "secret_key": secretKey,
        "otp_authentication": otp_authentication,
        "access_allowed": accessAllowed,
        "system_id": systemId
      }, { headers: { "Authorization": `Token ${JSON.parse(localStorage.getItem("login")) && JSON.parse(localStorage.getItem("login")).token}` } }).then((res) => {
        setIsDataLoading(false)
        props.handleCancel()
      }).catch(e => { console.log(e); setIsDataLoading(false) })
    } else {
      let payload;
      if(showResetPassword){
        payload = {"password":password,"id": props.selectedRow.id}
      } else {
        payload = {
          "id": props.selectedRow.id, 
          "whatsapp_phone_no_id": whatsappNumber, 
          "email": email, 
          "file_name": fileName, 
          "scheme_file_name": schemeFileName,
          "stock_file_name": stockFileName,
          "whatsapp_token": token, 
          "is_active": activeStaus, 
          "whatsapp_account_id": whatsappAccId, 
          "allowed_app_user": devicesAllowed,
          "name": name,
          "msg_limit": messageLimit,
          "third_party_api": third_party_api,
          "mobile_number": mobileNumber,
          "expiry_date": expiryDate,
          "secret_key": secretKey,
          "otp_authentication": otp_authentication,
          "access_allowed": accessAllowed,
          "system_id": systemId
        }
      }
      axios.post(`${url}/simistocks/update_user`, payload, { headers: { "Authorization": `Token ${JSON.parse(localStorage.getItem("login")) && JSON.parse(localStorage.getItem("login")).token}` } }).then((res) => {
        setIsDataLoading(false)
        props.handleCancel()
      }).catch(e => { console.log(e); setIsDataLoading(false) })
    }
  }

  const handleFeatureAccessChange = e => {
    if(e.target.checked) {
      setAccessAllowed({...accessAllowed, [e.target.name]: true})
    } else {
      setAccessAllowed({...accessAllowed, [e.target.name]: null})
    }
    
}

  const handleGenerateSecretKey = () => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const generateSegment = (len) => {
      let segment = '';
      for (let i = 0; i < len; i++) {
        segment += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      return segment;
    };
    const result = `${generateSegment(4)}-${generateSegment(4)}-${generateSegment(4)}`;
    setSecretKey(result);
  }

  return (
    <div>
      <Dialog open={true} maxWidth="md" fullWidth>
        <DialogTitle>{showResetPassword ? "Reset Password" : props.selectedRow ? "Update User" : "Create User"}</DialogTitle>
        <DialogContent sx={{ px: { xs: 2, sm: 3 }, py: 2 }}>

          {showResetPassword ?
            <TextField
              
              label="Password"
              type="text"
              fullWidth
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          : <>
            {/* LOGIN DETAILS */}
            <Typography variant="subtitle2" sx={{ fontWeight: "bold", mt: 1, mb: 0.5 }}>Login Details</Typography>
            <Divider sx={{ mb: 1.5 }} />
            <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr" }, gap: "12px" }}>
              <TextField size="small" fullWidth label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
              {!props.selectedRow ? <TextField size="small" fullWidth label="Password" type="text" value={password} onChange={(e) => setPassword(e.target.value)} />
                : <FormControlLabel control={<Checkbox size="small" onClick={() => setActiveStatus(!activeStaus)} checked={activeStaus} />} label="Active Status" />}
              <TextField size="small" fullWidth label="Name" type="text" value={name} onChange={(e) => setName(e.target.value)} />
            </Box>

            {/* FILE DETAILS */}
            <Typography variant="subtitle2" sx={{ fontWeight: "bold", mt: 2.5, mb: 0.5 }}>File Details</Typography>
            <Divider sx={{ mb: 1.5 }} />
            <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr" }, gap: "12px" }}>
              <TextField size="small" fullWidth label="Sales File Name" type="text" value={fileName} onChange={(e) => setFileName(e.target.value)} />
              <TextField size="small" fullWidth label="Scheme File Name" type="text" value={schemeFileName} onChange={(e) => setSchemeFileName(e.target.value)} />
              <TextField size="small" fullWidth label="Stock File Name" type="text" value={stockFileName} onChange={(e) => setStockFileName(e.target.value)} />
            </Box>

            {/* WHATSAPP CREDENTIAL */}
            <Typography variant="subtitle2" sx={{ fontWeight: "bold", mt: 2.5, mb: 0.5 }}>WhatsApp Credential</Typography>
            <Divider sx={{ mb: 1.5 }} />
            <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr" }, gap: "12px" }}>
              <TextField size="small" fullWidth label="Whatsapp Phone No Id" type="text" value={whatsappNumber} onChange={(e) => setwhatsappNumber(e.target.value)} />
              <TextField size="small" fullWidth label="Whatsapp Token" type="text" value={token} onChange={(e) => settoken(e.target.value)} />
              <TextField size="small" fullWidth label="Whatsapp Account ID" type="text" value={whatsappAccId} onChange={(e) => setWhatsappAccId(e.target.value)} />
              <TextField size="small" fullWidth label="WA 3rd Party API" type="text" value={third_party_api} onChange={(e) => setWAThirdPartyAPI(e.target.value)} />
              <TextField size="small" fullWidth label="Message Limit" type="number" value={messageLimit} onChange={(e) => e.target.value >= 0 ? setMessageLimit(e.target.value) : null} />
            </Box>

            {/* SIMI WHATSAPP */}
            <Typography variant="subtitle2" sx={{ fontWeight: "bold", mt: 2.5, mb: 0.5 }}>Simi WhatsApp</Typography>
            <Divider sx={{ mb: 1.5 }} />
            <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr" }, gap: "12px", alignItems: "center" }}>
              <Button variant="outlined" size="small" fullWidth onClick={handleGenerateSecretKey} sx={{ height: 40, textTransform: "none" }}>Generate Key</Button>
              <TextField size="small" fullWidth label="Secret Key" type="text" value={secretKey} InputProps={{ readOnly: true }} InputLabelProps={{ shrink: !!secretKey }} />
              <TextField size="small" fullWidth type="date" label="Expiry Date" InputLabelProps={{ shrink: true }} value={expiryDate} onChange={(e) => setExpiryDate(e.target.value)} />
              <TextField size="small" fullWidth label="System ID" type="text" value={systemId} onChange={(e) => setSystemId(e.target.value)} />
            </Box>

            {/* APP/WEB CONFIG */}
            <Typography variant="subtitle2" sx={{ fontWeight: "bold", mt: 2.5, mb: 0.5 }}>App/Web Config</Typography>
            <Divider sx={{ mb: 1.5 }} />
            <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr" }, gap: "12px" }}>
              <TextField size="small" fullWidth label="No. of Devices Allowed" type="number" value={devicesAllowed} onChange={(e) => e.target.value >= 0 ? setDevicesAllowed(e.target.value) : null} />
              <TextField size="small" fullWidth label="Mobile Number" type="number" value={mobileNumber} onChange={(e) => e.target.value >= 0 ? setMobileNumber(e.target.value) : null} />
            </Box>

            {/* OPTIONS */}
            <Typography variant="subtitle2" sx={{ fontWeight: "bold", mt: 2.5, mb: 0.5 }}>Options</Typography>
            <Divider sx={{ mb: 1 }} />
            <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr 1fr", sm: "1fr 1fr 1fr", md: "1fr 1fr 1fr 1fr" }, gap: "4px 0" }}>
              <FormControlLabel sx={{m: 0}} control={<Checkbox size="small" name={"otp_authentication"} checked={otp_authentication} onClick={e => setOTPAuth(!otp_authentication)} />} label={<Typography variant="body2">OTP Auth</Typography>} />
              <FormControlLabel sx={{m: 0}} control={<Checkbox size="small" name={"admin"} checked={accessAllowed?.admin} onClick={handleFeatureAccessChange} />} label={<Typography variant="body2">Admin Previlages</Typography>} />
              <FormControlLabel sx={{m: 0}} control={<Checkbox size="small" name={"sales"} checked={accessAllowed?.sales} onClick={handleFeatureAccessChange} />} label={<Typography variant="body2">Sales</Typography>} />
              <FormControlLabel sx={{m: 0}} control={<Checkbox size="small" name={"stock"} checked={accessAllowed?.stock} onClick={handleFeatureAccessChange} />} label={<Typography variant="body2">Stock</Typography>} />
              <FormControlLabel sx={{m: 0}} control={<Checkbox size="small" name={"whatsAppBulk"} checked={accessAllowed?.whatsAppBulk} onClick={handleFeatureAccessChange} />} label={<Typography variant="body2">WhatsApp Bulk</Typography>} />
              <FormControlLabel sx={{m: 0}} control={<Checkbox size="small" name={"whatsAppChat"} checked={accessAllowed?.whatsAppChat} onClick={handleFeatureAccessChange} />} label={<Typography variant="body2">WhatsApp Chat</Typography>} />
              <FormControlLabel sx={{m: 0}} control={<Checkbox size="small" name={"whatsAppStatus"} checked={accessAllowed?.whatsAppStatus} onClick={handleFeatureAccessChange} />} label={<Typography variant="body2">Promot Msg Status</Typography>} />
              <FormControlLabel sx={{m: 0}} control={<Checkbox size="small" name={"blockList"} checked={accessAllowed?.blockList} onClick={handleFeatureAccessChange} />} label={<Typography variant="body2">Block List</Typography>} />
              <FormControlLabel sx={{m: 0}} control={<Checkbox size="small" name={"quickWA"} checked={accessAllowed?.quickWA} onClick={handleFeatureAccessChange} />} label={<Typography variant="body2">Quick WhatsApp</Typography>} />
              <FormControlLabel sx={{m: 0}} control={<Checkbox size="small" name={"attachment"} checked={accessAllowed?.attachment} onClick={handleFeatureAccessChange} />} label={<Typography variant="body2">Attachment</Typography>} />
              <FormControlLabel sx={{m: 0}} control={<Checkbox size="small" name={"device"} checked={accessAllowed?.device} onClick={handleFeatureAccessChange} />} label={<Typography variant="body2">Device</Typography>} />
              <FormControlLabel sx={{m: 0}} control={<Checkbox size="small" name={"phoneNumberSearch"} checked={accessAllowed?.phoneNumberSearch || accessAllowed?.imeiSearch} onClick={handleFeatureAccessChange} />} label={<Typography variant="body2">Phone No. Search</Typography>} />
            </Box>
            <Typography variant="body2" sx={{ cursor: "pointer", textDecoration: "underline", mt: 1 }} onClick={() => setShowResetPassword(true)}>Reset password</Typography>
          </>}
        </DialogContent>
        <DialogActions style={{display: "flex", justifyContent: "center"}}>
          <Button variant="outlined" style={{border: "1px solid rgba(25, 118, 210, 0.5)", color: "#1976d2"}} onClick={props.handleCancel}>Cancel</Button>
          <Button variant='contained' style={{backgroundColor: "#1976d2"}} onClick={createUser} >{showResetPassword || props.selectedRow ? "Update" : "Create"}</Button>
          {(showResetPassword || props.selectedRow) && <Button variant='contained' color={"error"} onClick={props.handleDelete} >Delete</Button>}
        </DialogActions>
      </Dialog>
    </div>
  );
}
